import * as React from 'react';
import { cn } from '@noor/lib/cn';
import { Skeleton } from './skeleton';

export interface StatCardProps {
  label: string;
  value: React.ReactNode;
  subValue?: React.ReactNode;
  isLoading?: boolean;
  className?: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export function StatCard({
  label,
  value,
  subValue,
  isLoading = false,
  className,
  icon: Icon,
}: StatCardProps) {
  return (
    <div
      className={cn(
        'relative flex h-[94px] flex-col justify-between rounded-[12px] bg-white p-5 transition-all duration-200 dark:bg-card',
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <p className="text-[14px] font-medium tracking-[-0.28px] text-[#9ca3af]">
          {label}
        </p>
        {Icon && <Icon className="size-4 text-muted-foreground" />}
      </div>

      <div className="flex items-baseline gap-2">
        {isLoading ? (
          <Skeleton className="h-6 w-24 rounded-md" />
        ) : (
          <p className="text-[20px] leading-[26px] font-semibold tracking-[-0.4px] text-foreground">
            {value}
          </p>
        )}
        {subValue && !isLoading && (
          <span className="text-xs text-muted-foreground">{subValue}</span>
        )}
      </div>
    </div>
  );
}
